import * as R from 'ramda'

/**
 * Scores a project considers outside the preferred range for its role.
 *
 * The backend decides which traits these are, from the thresholds configured on
 * the project, and returns them on the candidate as `caution_scores`.
 *
 * This module deliberately depends on nothing else, so that the rule stays
 * testable on its own.
 */

export const GMA_FACTOR = 'GMA'

/** The factors shown under the personality tab, see `getFactors` in the model */
export const PERSONALITY_FACTORS = [
  'Agreeableness',
  'Conscientiousness',
  'Extraversion',
  'Openness to Experience',
  'Emotional Stability',
  'Neuroticism',
  'Hardiness',
]

/**
 * The flagged traits of the candidate on screen.
 *
 * A sign can only speak for one candidate, so nothing is flagged while two are
 * being compared.
 */
export const getCautions = (response, candidates) =>
  candidates.length === 1 ? response?.[0]?.caution_scores ?? [] : []

export const hasCaution = (cautions, factor) => R.includes(factor, cautions)

/** How many flagged traits belong to the personality factors */
export const countPersonalityCautions = cautions =>
  R.length(R.intersection(cautions, PERSONALITY_FACTORS))
